export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_07.3eb8cd60.jpg";